import * as busyCounter from '../../../sharedmodules/action-creators/busy-counter';

import { createSuccessMessage } from '../../../sharedmodules/action-creators/alert-messages';
import { editNotificationSequence } from '../repositories/editNotificationSequence';
import { handleError } from '../../../sharedmodules/services/error-handlers';
import { readNotificationData } from './read-notification';
import { translate } from '../../../sharedmodules/services/translation-service';

export const updateNotificationSequenceData = (getAccessToken,
    notificationSequence) => async (dispatch) => {

    dispatch(busyCounter.increaseBusyCounter());
    try {

        await editNotificationSequence(getAccessToken, notificationSequence);
        dispatch(createSuccessMessage(translate('NOTIFICATION_SEQUENCE_UPDATED_SUCCESSFULLY')));

    } catch (error) {

        handleError(error);

    } finally {

        dispatch(readNotificationData(getAccessToken));
        setTimeout(() => {

            dispatch(busyCounter.decreaseBusyCounter());

        }, 150);

    }

};
